import { render, staticRenderFns } from "./index.vue?vue&type=template&id=238ff21c"
import script from "./rentFreePeriod.js?vue&type=script&lang=js&external"
export * from "./rentFreePeriod.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports